var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollapseUpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9993 22.5C26.6603 22.5 26.3198 22.386 26.0393 22.152L17.9828 15.438L9.93976 21.9105C9.29626 22.431 8.35126 22.329 7.83076 21.6825C7.31176 21.0375 7.41376 20.094 8.06026 19.5735L17.0603 12.3315C17.6153 11.883 18.4118 11.889 18.9608 12.348L27.9608 19.848C28.5968 20.3775 28.6823 21.324 28.1528 21.96C27.8558 22.3155 27.4298 22.5 26.9993 22.5Z",
    fill: "#2E3A59"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseUpIcon);
export default __webpack_public_path__ + "static/media/collapseUpIcon.c2c893e7305bd3b6b74674b5ad943061.svg";
export { ForwardRef as ReactComponent };